module.exports = __webpack_public_path__ + "static/media/loding-gif.149de675.gif";